module.exports = __webpack_public_path__ + "static/media/Mach_mit_bei_Mr._Frozy_s_Weihnachtsgewinnspiel.61aa851c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/docs/Mach_mit_bei_Mr._Frozy_s_Weihnachtsgewinnspiel.pdf
// module id = 111
// module chunks = 0